<h3
  [ngClass]="tourStyle()"
  (click)="open()"
>
  {{ name }}
  <div style="text-align: center; font-weight: lighter" [ngClass]="getPlacesClass()">
    <div *ngIf="place_from !== 'None' && place_to !== 'None' && place_from !== place_to">
      Места <span style="margin-left: 5px">{{place_from}} - {{place_to}}</span>
    </div>
    <div *ngIf="place_from !== 'None' && place_to !== 'None' && place_from === place_to">
      Место <span style="margin-left: 5px">{{place_from}}</span>
    </div>
    <div *ngIf="place_from !== 'None' && place_to === 'None'">
      Место <span style="margin-left: 5px">{{place_from}}</span>
    </div>
    <div *ngIf="place_from === 'None' && place_to !== 'None'">
      Место <span style="margin-left: 5px">{{place_to}}</span>
    </div>
    <div *ngIf="place_from === 'None' && place_to === 'None'">
<!--      Места <span style="margin-left: 5px">{{place_from}} - {{place_to}}</span>-->
      place holder
    </div>
  </div>
</h3>
